import React, { useState, useContext } from 'react';
import { Card, Col, Button } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';
import star from '../assets/star.png';
import { DEVICE_ROUTE } from '../routes';

const DeviceItem = observer(({ device }) => {
    const navigate = useNavigate();
    const { basket } = useContext(Context);
    const [added, setAdded] = useState(false);

    const imageUrl = `/images/${device.img}`;

    const handleAddToBasket = async (e) => {
        e.stopPropagation();
        await basket.addDevice(device);
        setAdded(true);
        setTimeout(() => setAdded(false), 2000);
    };

    const handleCardClick = () => {
        navigate(DEVICE_ROUTE + '/' + device.id);
    };

    return (
        <Col xs={6} sm={6} md={4} lg={3} className="mb-3 px-2">
            <Card 
                className="device-card h-100"
                style={{ cursor: 'pointer' }}
                onClick={handleCardClick}
            >
                <div className="text-center p-2" style={{ overflow: 'hidden' }}>
                    <Image
                        width="100%"
                        height="auto"
                        src={imageUrl}
                        onError={(e) => {
                            e.target.src = 'https://picsum.photos/300/300';
                        }}
                        style={{ 
                            objectFit: 'contain',
                            width: '100%',
                            height: 'auto',
                            minHeight: '200px',
                            maxHeight: '300px',
                            borderRadius: '15px',
                            backgroundColor: '#f8f9fa'
                        }}
                    />
                </div>
                <Card.Body className="p-2">
                    <div className="text-black-50 small text-truncate">{device.brand || 'Без бренда'}</div>
                    <div className="text-truncate" style={{ fontSize: '0.9rem' }}>{device.name}</div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        <span className="fw-bold" style={{ fontSize: '1rem' }}>{device.price} ₽</span>
                        <div className="d-flex align-items-center">
                            <span className="me-1 small">{device.rating || 0}</span>
                            <Image src={star} width={14} height={14} />
                        </div>
                    </div>
                    <Button 
                        variant={added ? 'success' : 'outline-dark'} 
                        size="sm" 
                        className="mt-2 w-100"
                        onClick={handleAddToBasket}
                        disabled={added}
                        style={{ fontSize: '0.8rem' }}
                    >
                        {added ? '✅ Добавлено' : '🛒 В корзину'}
                    </Button>
                </Card.Body>
            </Card>
        </Col>
    );
});

export default DeviceItem;
